import { TYPE } from 'Reducers/dynamicContent';

export const fetchDynamicContent = payload => {
    return (dispatch, _, { get }) => {
        return dispatch(get(payload.url, TYPE));
    };
};
